import { bool, string, func } from 'prop-types'
import { Input, Button, kuiperClassNames } from '@opallabs/kuiper'
import './styles.scss'

const CtaPopoverContent = ({
  onCopyLink,
  onUrlChange,
  originalUrl,
  readOnly,
  updateUrl,
  value,
}) => {
  const urlUpdated = value !== originalUrl
  return (
    <div className={kuiperClassNames('cta-popover-content')}>
      <Input
        disabled={readOnly}
        onChange={onUrlChange}
        placeholder="https://"
        shouldValidate={false}
        theme="light"
        title="CTA URL"
        value={value}
      />
      {!readOnly && (
        <Button
          className="save-cta"
          disabled={!urlUpdated}
          label="Save"
          onClick={() => updateUrl(value)}
        />
      )}
      <Button
        className="copy-cta"
        onClick={onCopyLink}
        disabled={!value || urlUpdated}
        label="Copy"
        type="secondary"
      />
    </div>
  )
}

CtaPopoverContent.propTypes = {
  onCopyLink: func,
  onUrlChange: func,
  originalUrl: string,
  readOnly: bool,
  updateUrl: func,
  value: string,
}

export default CtaPopoverContent
